module.exports = __webpack_public_path__ + "img/avatar.4971c334.png";